import React, { Component } from 'react';
import {Route} from 'react-router-dom';
import './reset.css';
import './App.css';

import {
  ViewHome,
  ViewWashes
} from './views';

class App extends Component {
  render() {
    return (
      <div id="root" className="rdp-covid-19">
        <Route exact={true} path="/" component={ViewHome}/>
        <Route exact={true} path="/washes/:type" component={ViewWashes}/>
      </div>
    );
  }
}

export default App;
